export default __webpack_public_path__ + "static/media/devona.ddf430eb.png";